import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { STORE_CONFIG } from "./config/store";

const rootElement = document.getElementById("root");
const description = document.querySelector('meta[name="description"]');
document.title = `${STORE_CONFIG.brand} | Cards, Gifts & Home`;
if (description) {
  description.setAttribute("content", `Shop original cards, characterful mugs, soft gifts and useful home textiles from ${STORE_CONFIG.brand} in ${STORE_CONFIG.operatingRegion}.`);
}

// 使用 hydrateRoot 以支持 react-snap 预渲染
// 如果页面已经有预渲染的内容，React 会复用它
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  // 如果没有预渲染内容（比如在开发模式），使用正常的 render
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
